import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { GestionTitreService } from '@services/navigation/gestion-titre.service';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { Router } from '@angular/router';
import { AccessibiliteService } from '@services/accessibilite.service';

@Component({
  selector: 'app-fin-parcours',
  templateUrl: './fin-parcours.component.html',
  styleUrl: './fin-parcours.component.scss',
  standalone: false,
})
export class FinParcoursComponent implements OnInit, AfterViewInit {
  private readonly gestionTitreService = inject(GestionTitreService);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);
  private readonly router = inject(Router);
  private readonly accessibiliteService = inject(AccessibiliteService);

  status!: string;
  codeErreur!: string;
  messageErreur!: string;

  constructor() {
    const navigation = this.router.currentNavigation();
    this.status = navigation?.extras?.state?.status as string;
    this.codeErreur = navigation?.extras?.state?.codeErreur as string;
    this.messageErreur = navigation?.extras?.state?.messageErreur as string;
  }

  ngOnInit(): void {
    this.gestionTitreService.addTitreOnglet('titreOnglet.finParcours');
    this.cybermetrieCoordonneesService.transactionEof([
      this.status,
      this.codeErreur ?? null,
      this.messageErreur ?? null,
    ]);
  }

  ngAfterViewInit(): void {
    this.accessibiliteService.setFocus('#titreFinParcours');
  }
}
